export enum Tier {
  Lite = 'Lite',
  Pro = 'Pro',
}

export enum Interval {
  Monthly = 'Monthly',
  Yearly = 'Yearly',
}
